<template>
    <div class="operation">
        <Title chineseTitle="运行监控" englishTitle="operation monitoring and controlling" />
        <div class="operationHandle" @click="showDeviceList = !showDeviceList">
            <img src="../../assets/img/change.png" alt="" />
            <span>{{details[currentDeviceDetail].name}}</span>
        </div>
        <div class="deviceList" v-show="showDeviceList">
            <img class="close" @click="showDeviceList = false" src="../../assets/img/close.png" alt="关闭" />
            <div class="type row-center">
                <span>设备列表</span>
            </div>
            <div class="names">
                <span v-for="(item, index) in details" :class="{ active: currentDeviceDetail === index }" :key="index"
                    @click="currentDeviceDetail = index">
                    {{ item.name }}
                </span>
            </div>
        </div>

        <div class="operationContent">
            <data-item :data="[
                {
                    key: '功率因数',
                    value: $store.state.MQTTObj[details[currentDeviceDetail].value + 'PF'],
                    unit: '',
                }, {
                    key: '在线总数',
                    value: 1,
                    unit: '',
                }]">
            </data-item>
            <data-item :data="[
                {
                    key: '有功功率',
                    value: $store.state.MQTTObj[details[currentDeviceDetail].value + 'PA'],
                    unit: 'w',
                }, {
                    key: '离线总数',
                    value: 0,
                    unit: '',
                }]">
            </data-item>
            <data-item :data="[
                {
                    key: '无功功率',
                    value: $store.state.MQTTObj[details[currentDeviceDetail].value + 'PR'],
                    unit: 'w',
                }, {
                    key: '不平衡度',
                    value: $store.getters.unbalance(details[currentDeviceDetail].value),
                    unit: '%',
                }]">
            </data-item>
        </div>
    </div>
</template>

<script>
    import Title from "@/components/Title.vue";
    import DataItem from "@/components/DataItem";

    export default {
        name: "SiteOperationData",
        components: {
            Title,
            DataItem,
        },
        props: ["areaId"],
        data() {
            return {
                currentDeviceDetail: 0,
                showDeviceList: false,
                details: [
                    [{
                        name: "A1配电柜",
                        value: "A1/ZTR1/",
                    }, {
                        name: "A2配电柜",
                        value: "A2/ZTR1/",
                    }],
                ],
            }
        },
        mounted() {
            this.details = this.$store.getters.getDevicesList(this.areaId)
        }
    };
</script>

<style lang="less" scoped>
    .operation {
        position: fixed;
        top: 880/108vh;
        left: 14600/192vw;

        .operationHandle {
            width: 4000/192vw;
            height: 400/108vh;
            background: #030d18;
            opacity: 0.75;
            margin-left: 1vw;
            font-size: 18px;
            color: #e6f3fd;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            cursor: pointer;

            img {
                margin-left: 12px;
                margin-right: 11px;
                width: 16px;
                height: 13px;
            }
        }

        .operationContent {
            width: 4000/192vw;
            height: 1200/108vh;
            background: #030d18;
            opacity: 0.75;
            margin-left: 1vw;
            overflow: hidden;
            display: flex;
            flex-direction: row;
        }

    }

    .deviceList {
        width: 100%;
        height: 100%;
        z-index: 100;
        position: absolute;
        left: -4080/192vw;
        top: 0;
        color: #ffffff;
        font-size: 18px;
        background-image: url("../../assets/img/安防列表.png");
        background-size: 100% 100%;
        padding-top: 23px;
        padding-left: 24px;
        padding-right: 18px;

        .close {
            position: absolute;
            top: 23px;
            right: 20px;
            cursor: pointer;
        }

        .active {
            color: #0d94ff;
        }

        .names {
            height: 75%;
            align-items: flex-start;
            overflow-y: auto;
            display: flex;
            flex-direction: column;

            span {
                margin-bottom: 23px;
                cursor: pointer;
            }
        }

        .type {
            justify-content: flex-start;
            border-bottom: 1px solid rgba(255, 255, 255, 0.75);
            margin-bottom: 16px;

            span {
                margin-right: 33px;
                margin-bottom: 13px;
            }
        }
    }

    .names::-webkit-scrollbar {
        width: 5px;
        height: 1px;
    }

    .names::-webkit-scrollbar-thumb {
        border-radius: 5px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(255, 255, 255, 0.7);
    }

    // .names::-webkit-scrollbar-track {
    //     box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    //     border-radius: 10px;
    //     background: #111;
    // }
</style>